export const CDStheme = {
  darkTheme: {
    colors: {
      background: "#201E20",
      inputBackground: "#100f10",
      danger: "#FF7651",
      warning: "#f7ce6b",
      success: "#CFF16B",
      text: "#FFFFFF",
      white: "#FFFFFF",
      lightGray: "#F0F0F0",
      gray: "#ACA9B3",
      darkGray: "#5F5D5F",
      coal: "#323132",
      mediumBlack: "#171414",
      darkBlack: "#100f10",
      green: "#CFF16B",
      purpleRed: "#9f3552",
      yellow: "#f7ce6b",
      buttonBackground: "#FFF",
      purple: "#C86BF2",
    },
  },
  lightTheme: {
    colors: {
      background: "#FFF",
      text: "#201E20",
      buttonBackground: "#CFF16B",
      inputBackground: "#F0F0F0",
      gray: "#ACA9B3",
      green: "#CFF16B",
      darkGray: "#201E20",
      white: "#FFFFFF",
      purple: "#C86BF2",
      disabledBackground: "#cacaca",
      disabledText: "#fafafa",
      danger: "#FF7651",
      warning: "#f7ce6b",
      success: "#CFF16B",
      lightGray: "#F0F0F0",
      coal: "#323132",
      mediumBlack: "#171414",
      darkBlack: "#100f10",
      purpleRed: "#9f3552",
      yellow: "#f7ce6b",
    },
  },
  font: {
    size: {
      smallest: "12px",
      smaller: "13px",
      small: "14px",
      default: "16px",
      medium: "20px",
      large: "24px",
      larger: "32px",
      largest: "40px",
      h1: "1.5em", //24px
      h2: "1.25em", //20px
      h3: "1.25em", //20px
      h4: "1em", //16px
      h5: "1em", //16px
      h6: "0.875em", //14px
      // smallest: "12px",
      // smaller: "13px",
      // small: "14px",
      // medium: "16px",
      // large: "24px",
      // larger: "32px",
      // largest: "40px",
    },
    color: {
      lightBlack: "#5f5d5f",
      lightGrey: "#ACA9B3",
      white: "#ffff",
    },
    weight: {
      lightest: "100",
      light: "300",
      regular: "400",
      bold: "700",
      extraBold: "900",
    },
    family: {
      maisonNeue: "MaisonNeue",
    },
    lineHeight: {
      medium: "26px",
    },
  },
  spacings: {
    smallest: "8px",
    smaller: "10px",
    small: "14px",
    medium: "16px",
    large: "24px",
    larger: "32px",
    largest: "40px",
  },
  gap: {
    smallest: "0.3em", // 4.8px
    smaller: "0.5em", // 8px
    small: "0.7em", // 11,2px
    medium: "1em", // 16px
    large: "1.3em", // 20,8px
    larger: "1.5em", // 24px
    largest: "1.7em", // 27,2px
  },
};
